import React, { FC } from "react";
import { usePager } from "../hooks";


const Pager: FC = () => {
  const { page, setPage, totalPages } = usePager()
  if (totalPages < 2 || page === undefined || page === null) return null

  var leftArrow = page !== 0 ?
    <i className="fa fa-chevron-left" onClick={() => setPage(page - 1)}></i> :
    <i className="fa fa-chevron-left disabled"></i>,
    rightArrow = page !== (totalPages - 1) ?
      <i className="fa fa-chevron-right" onClick={() => setPage(page + 1)}></i> :
      <i className="fa fa-chevron-right disabled"></i>;
  return (
    <div className="paging-group no-select">
      {leftArrow}
      <span className="paging-text">{page + 1} <small>of</small> {totalPages}</span>
      {rightArrow}
    </div>
  )
}

export default Pager;